// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__iKpwM","footer":"ModalCreateQualiphyProcedure_footer__3y0_8","additionData":"ModalCreateQualiphyProcedure_additionData__2ORHq"};